export default __webpack_public_path__ + "static/lbb-f4f57f302b118fc5b81f1caf0d0d1bf1.png";